import React from 'react';

import StaticBlock from 'common/StaticBlock/StaticBlock';

const PaymentFormFooter = ({ staticBlockSource }) => {
  const staticBlockOptions = { source: staticBlockSource };

  return (
    <span className="sub-title-text payment-form-static-block">
      <StaticBlock options={staticBlockOptions} />
    </span>
  );
};

export default PaymentFormFooter;
